import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API from "../utils/axiosInstance";
import "./AdminUploadEbook.css"; // Make sure this CSS file exists

const AdminUploadEbook = () => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [file, setFile] = useState(null);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [uploading, setUploading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user.id === 1) {
      setIsAuthorized(true);
    } else {
      alert("Access Denied: Only Admin can upload ebooks.");
      navigate("/dashboard");
    }
  }, [navigate]);

  const handleUpload = async (e) => {
    e.preventDefault();

    if (!file) return alert("Please select a file");

    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("ebook", file);

    try {
      setUploading(true);
      await API.post("/ebooks/upload", formData);
      alert("✅ Ebook uploaded successfully!");
      setTitle("");
      setDescription("");
      setFile(null);
    } catch (error) {
      console.error("Upload error:", error);
      alert("❌ Failed to upload the ebook.");
    } finally {
      setUploading(false);
    }
  };

  if (!isAuthorized) return null;

  return (
    <div className="admin-upload-container">
      <h2 className="upload-title">Upload a New Ebook</h2>
      <form className="upload-form" onSubmit={handleUpload}>
        <input
          type="text"
          placeholder="Ebook Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />
        <textarea
          placeholder="Ebook Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows="4"
          required
        ></textarea>
        <input
          type="file"
          accept="application/pdf"
          onChange={(e) => setFile(e.target.files[0])}
          required
        />
        <button type="submit" className="upload-btn" disabled={uploading}>
          {uploading ? "Uploading..." : "Upload Ebook"}
        </button>
      </form>
    </div>
  );
};

export default AdminUploadEbook;
